import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { detectCaps } from "@/lib/mirrorRtc";
import { GUIDES } from "./guides";
import CastPanel from "./CastPanel";
import CompatPanel from "./CompatPanel";

function Guides() {
  const [open, setOpen] = useState("jixxeo");
  const host = window.location.host;
  return (
    <div className="space-y-2" data-testid="mirror-guides">
      {GUIDES.map((g) => (
        <div key={g.id} className="rounded-3xl border border-white/10 bg-white/[0.03]" data-testid={`mirror-guide-${g.id}`}>
          <button onClick={() => setOpen(open === g.id ? "" : g.id)} className="w-full flex items-center gap-3 p-4 text-left" data-testid={`mirror-guide-toggle-${g.id}`}>
            <span className="flex-1 font-bold">{g.name}</span>
            <span className="mono text-[10px] uppercase tracking-widest text-[#00F0FF] bg-[#00F0FF]/10 rounded-full px-2 py-0.5">{g.tag}</span>
            <ChevronDown className={`w-4 h-4 transition-transform ${open === g.id ? "rotate-180" : ""}`} />
          </button>
          {open === g.id && (
            <ol className="px-4 pb-4 space-y-2">
              {g.steps.map((s, i) => (
                <li key={i} className="flex gap-3 text-sm text-white/75"><span className="mono text-[#00F0FF] font-bold">{i + 1}</span><span>{s.replaceAll("YOUR-SITE", host)}</span></li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  );
}

const TABS = [["cast", "Cast"], ["tvs", "TVs & compatibility"], ["guides", "Setup guides"]];

export default function MirrorApp() {
  const caps = useMemo(detectCaps, []);
  const [tab, setTab] = useState("cast");
  useEffect(() => { document.title = "Jixxeo Mirroring"; }, []);
  return (
    <div className="min-h-screen bg-[#05060a] text-white" style={{ fontFamily: "'Outfit',ui-sans-serif" }} data-testid="mirror-app">
      <div className="max-w-2xl mx-auto px-4 pt-4 pb-16">
        <div className="flex items-center gap-3">
          <Link to="/browse" className="text-xs mono uppercase tracking-widest text-white/75 hover:text-white py-2 pr-2" data-testid="mirror-back">← Apps</Link>
          <Link to="/mirror/tv" className="ml-auto text-[10px] mono uppercase tracking-widest text-[#00F0FF]" data-testid="mirror-this-is-tv">This is the TV →</Link>
        </div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl mt-6 leading-none">Jixxeo <span className="text-[#00F0FF]">Mirroring</span></h1>
        <p className="text-white/55 text-sm mt-3 max-w-md">Put your screen, photos and videos on the big screen. We'll tell you honestly what works on your device.</p>
        <div className="flex gap-1 mt-6 rounded-full bg-white/5 p-1 w-fit max-w-full overflow-x-auto">
          {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`mirror-tab-${k}`} className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${tab === k ? "bg-[#00F0FF] text-black" : "text-white/60"}`}>{l}</button>)}
        </div>
        <div className="mt-6">
          {tab === "cast" && <CastPanel caps={caps} />}
          {tab === "tvs" && <CompatPanel caps={caps} />}
          {tab === "guides" && <Guides />}
        </div>
      </div>
    </div>
  );
}
